<script setup lang="ts">
import {defineProps, getCurrentInstance, reactive, ref} from "vue";
import LoadingSpinner from "@/shared/components/loading/LoadingSpinner.vue";

const {$alert} = getCurrentInstance().appContext.config.globalProperties;
const {$axios} = getCurrentInstance().appContext.config.globalProperties;
const {$endpoint} = getCurrentInstance().appContext.config.globalProperties;
const load = ref(false)
const contactForm = reactive({
  client_full_name: "",
  client_email: "",
  client_object: "",
  client_message: "",
})
const contactValidator = () => {
  return contactForm.client_full_name == "" || contactForm.client_email == "" || contactForm.client_object == "" || contactForm.client_message == ""
}
const sendMessage = () => {
  load.value = true;
  if (contactValidator()) {
    $alert.fire({
      title: 'Ooops!',
      text: 'Veuillez correctement remplir le formulaire',
      icon: 'error',
      confirmButtonColor: '#D62F2F',
      confirmButtonText: 'Compris'
    })
    load.value = false
  } else {
    $axios.post($endpoint.ContactUs, contactForm).then((resp: any) => {
      console.error(resp)
      $alert.fire({
        title: 'Message envoyé!',
        text: resp.data.message,
        icon: 'success',
        confirmButtonColor: '#D62F2F',
        confirmButtonText: 'Compris'
      })
      contactForm.client_message = ""
      contactForm.client_full_name = ""
      contactForm.client_object = ""
      contactForm.client_email = ""
      load.value = false
    }).catch((err: any) => {
      load.value = false
      console.error(err)
    })
  }
}

const props = defineProps({
  title: {type: String, default: ''},
  subtitle: {type: String, default: ''},
  bgImageUrl: {type: String, default: ''},
  socialLink: {type: Array as () => string[], default: () => []}
});
</script>

<template>
  <div class="uk-padding uk-padding-remove-horizontal uk-padding-remove-bottom about-highlight">
    <div class="uk-container">
      <div class="uk-grid">

        <div class="uk-width-1-3@xl uk-width-1-3@l uk-width-1-2@m uk-margin-medium-top">
          <img :src="bgImageUrl" alt="Happy Family" class="">
        </div>

        <div class="uk-width-2-3@xl uk-width-2-3@l uk-width-1-2@m">
          <h3 class="uk-margin-remove-bottom uk-margin-small-top">{{ props.title }}</h3><!-- title -->
          <p class="impx-text-large uk-margin-medium-bottom uk-margin-small-top">{{ props.subtitle }}</p>
          <!-- highlight items -->
          <ul class="uk-child-width-1-2@xl uk-child-width-1-2@l uk-child-width-1-2@m uk-child-width-1-2@s impx-features-hl uk-margin-top uk-grid-match uk-flex-center uk-margin-medium-bottom"
              data-uk-grid><!-- reason items  -->
            <li v-for="(socialItem, index) in props.socialLink" :key="index"><!-- reason item #1 -->
              <div class="uk-grid-medium" data-uk-grid>
                <div class="uk-width-auto@xl uk-width-auto@l uk-width-auto@l uk-width-auto@s">
                  <i  :class="[socialItem.icon, 'fa-2x', 'impx-text-csa']"></i>
                </div>
                <div
                    class="uk-width-expand@xl uk-width-expand@l uk-width-expand@l uk-width-auto@s impx-margin-top-remove">
                  <h5 class="uk-margin-remove">{{ socialItem?.title }}</h5>
                  <a :href="socialItem?.url">
                    <p class="uk-margin-small-top">{{ socialItem?.subtitle }}</p>
                  </a>
                </div>
              </div>
            </li><!-- reason item #1 end -->
          </ul><!-- reason items end -->
        </div>

      </div>
    </div>
  </div>
  <div class="uk-container">
    <loading-spinner v-if="load"></loading-spinner>

    <div class="uk-flex uk-flex-right">
      <div class="uk-width-1-1@xl uk-width-1-1@l uk-width-1-3@m uk-width-1-1@s">
        <!-- booking form -->
        <div class="bg-color-csa uk-padding impx-padding-medium uk-margin-medium-bottom uk-box-shadow-medium">

          <div class="impx-hp-booking-form side-form uk-margin-bottom uk-margin-remove-top">
            <h6 class="uk-heading-line uk-text-center uk-light uk-text-uppercase"><span>Contactez-nous</span></h6>
            <div>
              <div class="uk-margin">
                <div class="uk-form-controls">
                  <div class="uk-inline">
                    <label class="uk-form-label">Nom complet</label>
                    <span class="uk-form-icon" data-uk-icon="icon: users"></span>
                    <input class="uk-input booking-arrival uk-border-rounded" v-model="contactForm.client_full_name"
                           type="text" placeholder="Votre civilité,  Nom et prénom">
                  </div>
                </div>
              </div>
              <div class="uk-margin">
                <div class="uk-form-controls">
                  <div class="uk-inline">
                    <label class="uk-form-label">Email</label>
                    <span class="uk-form-icon" data-uk-icon="icon: email"></span>
                    <input class="uk-input booking-departure uk-border-rounded" v-model="contactForm.client_email"
                           type="email" placeholder="serv@exampl.com">
                  </div>
                </div>
              </div>
              <div class="uk-margin">
                <div class="uk-form-controls">
                  <div class="uk-inline">
                    <label class="uk-form-label">Objet</label>
                    <span class="uk-form-icon" data-uk-icon="icon: message"></span>
                    <input class="uk-input booking-departure uk-border-rounded" v-model="contactForm.client_object"
                           type="text" placeholder="L'objet de votre message">
                  </div>
                </div>
              </div>
              <div class="uk-margin">
                <div class="uk-form-controls">
                  <div class="uk-inline">
                    <label class="uk-form-label">Message</label>
                    <span class="uk-form-icon" data-uk-icon="icon: message"></span>
                    <textarea class="uk-input  uk-border-rounded" style="height: 90px;" cols="16"
                              v-model="contactForm.client_message" rows="56">Votre message</textarea>
                  </div>
                </div>
              </div>
              <div>
                <label class="uk-form-label empty-label">&nbsp;</label>
                <button class="uk-button uk-width-1-2@xl uk-width-1-1@l uk-width-1-1@m uk-width-1-1@s"
                        @click="sendMessage()">Envoyer
                </button>
              </div>
            </div>
          </div>
          <!-- booking form -->
        </div>
        <!-- SIDEBAR END -->

      </div>

    </div>
  </div>
</template>

<style scoped>

</style>